import Vue from 'vue';
// import ms from 'ms';

import arrowIcon from '@/helpers/arrowIcon';

export default function devicesWebsocket(store) {
  function makeDeviceIcon(active, device) {
    return L.divIcon({
      iconSize: [20, 20],
      className: `device-marker${active ? '' : ' device-marker-inactive'}`,
      html: `
        ${arrowIcon(device.color)}
        <div class="device-name">${device.display_name}</div>
      `,
    });
  }

  let subscribedTenantId = null;

  function subscribeToDevices(tenantId) {
    // Cache the tenant we are subscribed to
    if (tenantId === subscribedTenantId) {
      return;
    }

    // If the tenant changed, unsubscribe from the previous tenant
    if (subscribedTenantId !== null) {
      const filters = { tenant_id: subscribedTenantId };
      Vue.prototype.$mol.off('devices-positions.position', filters);
      Vue.prototype.$mol.off('devices-metrics.metric', filters);
      Vue.prototype.$mol.off('devices.updated', filters);
    }

    subscribedTenantId = tenantId;

    Vue.prototype.$mol.on('devices-positions.position', { tenant_id: tenantId }, (pos) => {
      console.log(`devices-positions.position: ${pos.device_id}`);

      if (pos.device_id === undefined) {
        return;
      }

      const device = store.state.devices.devices.find(d => d.id === pos.device_id);

      if (!device || !pos.location) {
        return;
      }

      const latLng = L.latLng(pos.location.latitude, pos.location.longitude);

      if (!device.history) {
        Vue.set(device, 'history', [latLng]);
      } else {
        device.history.unshift(latLng);
      }

      device.history.splice(
        Vue.prototype.$config.map.deviceHistoryCount,
        device.history.length - Vue.prototype.$config.map.deviceHistoryCount,
      );

      if (device.location) {
        device.location.latlng = latLng;
        device.location.heading = pos.location.heading;
        device.location.timestamp = pos.location.timestamp;
        device.location.lastSeen = Date.now();

        if (device.location.age !== 'good') {
          device.location.age = 'good';
          Vue.set(device.location, 'locationIcon', makeDeviceIcon(true, device));
        }
      } else {
        Vue.set(device, 'location', {
          latlng: latLng,
          heading: pos.location.heading,
          timestamp: pos.location.timestamp,
          lastSeen: Date.now(),
          age: 'good',
          locationIcon: makeDeviceIcon(true, device),
        });
      }

      store.commit('devices/updateDevice', { device });
    });

    Vue.prototype.$mol.on('devices-metrics.metric', { tenant_id: tenantId }, (pos) => {
      console.log(`devices-metrics.metric: ${pos.device_id}`);

      if (pos.device_id === undefined) {
        return;
      }

      const device = store.state.devices.devices.find(d => d.id === pos.device_id);

      if (!device || !pos.status) {
        return;
      }

      if (pos.status && pos.status.battery !== undefined) {
        Vue.set(device, 'battery', pos.status.battery);
      }

      store.commit('devices/updateDevice', { device });
    });

    Vue.prototype.$mol.on('devices.updated', { tenant_id: tenantId }, (dev) => {
      console.log(`devices.updated: ${dev.id}`);

      const device = store.state.devices.devices.find(d => d.id === dev.id);

      if (!device) {
        return;
      }

      device.display_name = dev.display_name;
      device.color = dev.color;

      store.commit('devices/updateDevice', { device, refresh: true, dontEmit: true });
    });
  }

  function updateLocationsAge(devices) {
    devices.forEach((device) => {
      if (!device.location) {
        return;
      }

      const delay = Date.now() - new Date(device.location.timestamp);
      let age = 'timeout';

      if (delay < Vue.prototype.$config.map.deviceLagDelay) {
        age = 'good';
      } else if (delay < Vue.prototype.$config.map.deviceTimeoutDelay) {
        age = 'lag';
      }

      if (device.location.age !== age) {
        device.location.age = age; // eslint-disable-line no-param-reassign
        Vue.set(device.location, 'locationIcon', makeDeviceIcon(age === 'good', device));
      }
    });
  }

  /*
  function initSocket() {
    socket.on('update', (device) => {
      const dev = store.state.devices.devices.find(d => d.id === _d);
      store.commit('devices/updateDevice', { device: Object.assign(dev, device) });
    });

    socket.on('status', (devices) => {
      for (let i = 1; i < devices.length; i += 1) {
        const curr = devices[i];
        const prev = devices[i - 1];

        if (curr.pathLength) {
          const device = store.state.devices.devices.find(d => d.id === curr.id);
          const delay = curr.delay ? (curr.delay < 100 ? `${curr.delay}s` : ms(curr.delay * 1000)) : '∞'; // eslint-disable-line
          console.log(`${curr.id} -> ${prev.id}: vitesse moyenne: ${curr.averageSpeed}km/h distance: ${curr.pathLength || '-'}m temps écart: ${delay}`);

          if (device && device.location) {
            device.location.labelIcon = L.divIcon({
              iconSize: [50, 25],
              iconAnchor: [25, 35],
              className: 'device-label',
              html: delay,
            });
          }
        }
      }
    });
  }
  */

  store.subscribe((mutation, state) => {
    if (mutation.type === 'tenants/current') {
      store.dispatch('devices/fetchList', {
        tenantId: state.tenants.current.id,
      });
    }

    if (mutation.type === 'devices/setDevices') {
      subscribeToDevices(state.tenants.current.id);
    }

    if (mutation.type === 'devices/updateDevice' && mutation.payload.refresh) {
      const device = state.devices.devices.find(d => d.id === mutation.payload.device.id);

      if (!mutation.payload.dontEmit) {
        Vue.prototype.$mol.call('devices.update', {
          id: device.id,
          tenant_id: device.tenant_id,
          display_name: device.display_name,
          color: device.color,
        });
      }

      if (device.location) {
        Vue.set(device.location, 'locationIcon', makeDeviceIcon(device.location.age === 'good', device));
      }
    }
  });

  setInterval(() => {
    updateLocationsAge(store.state.devices.devices);
  }, 5 * 1000);
}
